'use client';

import { createContext, useContext, ReactNode } from 'react';
import { useBondsFiltersData } from './useBondsFiltersData';
import { IBondsFilterState } from '@/creditflowresearch/domain/vo/Bond/BondsFiltersContextData';

type BondsFiltersContextType = ReturnType<typeof useBondsFiltersData>;
export type TBondsFiltersPayload = BondsFiltersContextType['filtersPayload'];

export const BondsFiltersContext = createContext<BondsFiltersContextType>(null);

export const useBondsFiltersContext = () => {
  const context = useContext(BondsFiltersContext);
  if (!context) {
    throw new Error('useBondsFiltersContext must be used within the BondsFiltersContext');
  }
  return context;
};

interface IProps {
  children: ReactNode,
  initialFilter: IBondsFilterState,
}

const BondsFiltersContextProvider = ({ children, initialFilter }: IProps) => (
  <BondsFiltersContext.Provider value={ useBondsFiltersData(initialFilter) }>
    { children }
  </BondsFiltersContext.Provider>
);

export default BondsFiltersContextProvider;
